<template>
    <div class="m-media">
        <div class="m-media-item">
            <p class="m-media-item-title">优秀原创内容</p>
            <p class="m-media-item-text">趣头条平台吸纳了一大批个人大V，权威媒体，企业 组织等类型的自媒体创作方入驻为优质内容创建提供了良好的生态土壤</p>
            <!--<p style="text-align: center">-->
                <!--<a href="http://www.qutoutiao.net/media.html" class="m-media-btn">进入自媒体平台 ></a>-->
            <!--</p>-->
            <div style="position: relative;">
                <ul ref="imgList" @touchstart.stop.prevent="listTouchStart" @touchmove.stop.prevent="listTouchMove"  @touchend.stop.prevent="listTouchUp"
                    class="img-list-wrapper" v-bind:style="{width: imgListWidth + 'px',left:imgListX + 'px' }">
                    <li v-for="(item, index) of imgList" v-bind:key="index" class="img-list-item">
                        <img v-bind:src="item" alt="" class="img-list-item-img">
                    </li>
                </ul>
            </div>
        </div>
        <div class="m-media-item" style="background-color: #f8f9fa; padding-bottom: 0.5rem">
            <p class="m-media-item-title" style="padding-top: 2rem;">获得行业荣誉</p>
            <p class="m-media-item-text">短短18个月，凭借出色的内容创新与阅读体验成为资讯APP新锐独角兽并获得多项殊荣</p>
            <div style="position: relative; text-align: center;" >
                <!--<ul class="m-media-honor-wrapper" v-bind:style="{width: honorWidth + 'px'}" >-->
                <ul class="m-media-honor-wrapper" >
                    <li class="m-media-honor-item" v-for="(honor, index) of honerLists" v-bind:key="index">
                        <img :src="honor.pic">
                        <p v-html="honor.text"></p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="m-media-item">
            <p class="m-media-item-title">趣头条大事件</p>
            <p class="m-media-item-text">趣头条从2016年至2018年发展迅速，其中经历了几大的变革以及获得很多行业荣誉</p>
            <div class="qtt-list">
                <div class="qtt-list-left">
                    <div class="qtt-list-item">
                        <p class="qtt-list-time">2016.06.08</p>
                        <span class="under-line"></span>
                        <p class="qtt-list-text">
                            趣头条1.0上线 <br/>
                            倚靠差异化定位、独 <br/>
                            特的获客机制、快速  <br/>
                            发展的自媒体内容平  <br/>
                            台、以及基于深度学 <br/>
                            习的推荐算法 <br/>
                        </p>

                    </div>
                    <div class="qtt-list-item">
                        <p class="qtt-list-time">2017.03</p>
                        <span class="under-line"></span>
                        <p class="qtt-list-text">
                            趣头条2.0版本上线<br/>
                            用户及数据量大幅增长<br/>
                            趣头条在CheethLab<br/>
                            资讯类应用排行榜上<br/>
                            排名第11</p>
                    </div>
                    <div class="qtt-list-item">
                        <p class="qtt-list-time">2017.12</p>
                        <span class="under-line"></span>
                        <p class="qtt-list-text">
                            猎豹年度app排行榜<br/>
                            新闻类APP排行第<br/>
                            三，仅次于今日头<br/>
                            条和腾讯（猎豹<br/>
                            2017中国年度APP<br/>
                            排行榜）<br/>
                        </p>
                    </div>
                    <div class="qtt-list-item">
                        <p class="qtt-list-time">2018.06</p>
                        <span class="under-line"></span>
                        <p class="qtt-list-text">
                            趣头条上线2周年<br/>
                            3.0版本发布，优化阅<br/>
                            读体验及游戏化积分<br/>
                            激励机制，用户数持<br/>
                            续增长。APP Store <br/>
                            资讯类排行NO.1<br/>
                        </p>
                    </div>
                </div>
                <div class="qtt-list-center">
                    <span class="circle" style="width: 20px; height: 20px;">

                    </span>
                </div>
                <div class="qtt-list-right">
                    <div class="qtt-list-item">
                        <p class="qtt-list-time">2017年初</p>
                        <span class="under-line"></span>
                        <p class="qtt-list-text">
                            获得行业奖励<br/>
                            猎豹、WiFi 万能钥匙 <br/>
                            等第三方季度、年度 <br/>
                            报告均将趣头条列为 <br/>
                            增长最快的新闻资讯<br/>
                            类应用</p>
                    </div>
                    <div class="qtt-list-item">
                        <p class="qtt-list-time">2017.06.08</p>
                        <span class="under-line"></span>
                        <p class="qtt-list-text">
                            趣头条上线一周年<br/>
                            在OPPO应用商店排<br/>
                            行第4、Vivo应用商<br/>
                            店排行第5。App <br/>
                            Store资讯类排行免<br/>
                            费应用中一度排行NO.4</p>
                    </div>
                    <div class="qtt-list-item">
                        <p class="qtt-list-time">2018.03</p>
                        <span class="under-line"></span>
                        <p class="qtt-list-text">
                            完成B轮融资<br/>
                            完成超2亿美元B轮<br/>
                            融资，投后估值超16 <br/>
                            亿美金</p>
                    </div>
                    <div class="qtt-list-item">
                        <p class="qtt-list-time">2018.09</p>
                        <span class="under-line"></span>
                        <p class="qtt-list-text">
                            美国纳斯达克上市<br/>
                            成为移动内容聚合<br/>
                            第一股</p>
                    </div>
                </div>
                <p style="text-align: center;font-family: PingFangSC-Light;font-size: 12px;color: #4a4a4a;margin-top: -1rem">我们会一步一步继续前进<br/>从现在走到未来</p>
            </div>
        </div>
        <div class="m-media-item" style="background-color: #f8f9fa;">
            <p class="m-media-item-title">获得行业荣誉</p>
            <p class="m-media-item-text">短短18个月，凭借出色的内容创新与阅读体验成为资讯APP新锐独角兽并获得多项殊荣</p>
            <ul class="web-logo-list">
                <li v-for="(item, index) of webLogoList" v-bind:key="index">
                    <a :href="urlList[index].mobileLink  !== '' ? urlList[index].mobileLink :urlList[index].link">
                        <img :src="item" alt="">
                    </a>
                </li>
            </ul>
        </div>
        <div class="m-media-item" style="background-color: #ffffff;">
            <p class="m-media-item-title">媒体报道</p>
            <p class="m-media-item-text">趣头条在企业快速发展中 <br/>多次获得行业内各类权威性知名媒体报道</p>
            <p style="text-align: center;">
                <img style="margin: 33px auto 0; height: 100%; width: 100%; box-sizing: border-box; padding: 0 17px" src="//static-oss.qutoutiao.net/about/news/0115/7.jpg" alt="">
            </p>
        </div>
    </div>
</template>

<script>
import indexData from 'assets/js/indexData';

export default {
    name: 'Media',
    comments: {
        indexData,
    },
    data() {
        return {
            imgList: [],
            webLogoList: [],
            urlList: indexData.mediaList,
            honerLists: indexData.honorList,
            honorWidth: indexData.honorList.length * 230,
            honorOffset: 0,
            imgListWidth: 0,
            imgListX: 0,
            imgListStartX: 0,
            imgMoveX: 0,
        };
    },
    methods: {
        setImgList() {
            let num = 11;
            for (let i = 1; i <= num; i++) {
                this.imgList.push(
                    require('../../../assets/img/mIndex/' + i + '.png'),
                );
            }
            this.imgListWidth = this.imgList.length * 90;
        },
        setWebLogo() {
            let num = 7;
            for (let i = 1; i <= num; i++) {
                this.webLogoList.push(
                    require('../../../assets/img/mIndex/0' + i + '.png'),
                );
            }
        },
        listTouchStart(event) {
            this.imgListStartX = event.changedTouches[0].pageX;
        },
        listTouchMove(event) {
            // let startX = this.imgListStartX;
            let num = Math.floor(
                event.changedTouches[0].pageX - this.imgListStartX,
            );
            let domLeft = this.$refs.imgList.style.left.replace('px', '') - 0;
            this.imgMoveX = num;
            if (num > 0) {
                if (domLeft >= 0) {
                    this.imgListX = 0;
                    return;
                }
                this.imgListX += 22;
            } else {
                if (
                    -domLeft >=
                    this.imgListWidth - document.body.offsetWidth - 30
                ) {
                    this.imgListX =
                        this.imgListWidth - document.body.offsetWidth;
                    this.imgListX *= -1;
                    return;
                }
                this.imgListX -= 22;
            }
        },
        listTouchUp() {
            // if (this.imgListX + this.imgMoveX >= 0) {
            //     this.imgListX = 0;
            //     return;
            // } else if (
            //     this.imgListX + this.imgMoveX <=
            //     document.body.offsetWidth - this.honorWidth
            // ) {
            //     this.imgListX =
            //         this.honorWidth * -1 + document.body.offsetWidth - 30;
            //     return;
            // }
            // this.imgListX = this.imgListX + this.imgMoveX;
        },
    },
    mounted() {
        this.setImgList();
        this.setWebLogo();
    },
};
</script>

<style  lang="less">
.m-media {
    background-color: #ffffff;
    width: 100%;
    overflow: hidden;
    font-family: PingFangSC-Regular;
}
.m-media-item {
    padding-top: 2rem;
    padding-bottom: 1.214rem;
}
.m-media-item-title {
    font-size: 0.678rem;
    color: #333333;
    letter-spacing: 1px;
    line-height: 0.642rem;
    text-align: center;
    padding-bottom: 0.892rem;
}
.m-media-item-text {
    font-size: 0.5rem;
    color: #4a4a4a;
    letter-spacing: 1px;
    text-align: center;
    margin: 0 auto;
    max-width: 12rem;
    line-height: 0.785rem;
    padding: 0 0.317rem 0 0.317rem;
    box-sizing: border-box;
}
.m-media-btn {
    border: 1px solid #41b466;
    width: 4.735rem;
    height: 1.25rem;
    display: inline-block;
    line-height: 1.25rem;
    text-align: center;
    color: #41b466;
    margin-top: 25px;
}
.img-list-wrapper {
    height: 3.071rem;
    position: absolute;
    left: 0;
}
.img-list-item {
    display: inline-block;
    height: 3.071rem;
    width: 90px;
    box-sizing: border-box;
    padding: 0.25rem;
    background: #ffffff;
    /*box-shadow: 0 4px 7px 0 rgba(0, 0, 0, 0.08);*/
    border-radius: 2.4px;
}
.img-list-item-img {
    height: 2.657rem;
    width: 2.745rem;
}
.qtt-list {
    width: 100%;
    position: relative;
    padding-top: 0.714rem;
    height: 900px;
    vertical-align: top;
}
.qtt-list-right {
    vertical-align: top;
    display: inline-block;
    text-align: left;
    width: 40%;
    margin-top: 4.642rem;
}
.qtt-list-center {
    display: inline-block;
    height: 100%;
    width: 18%;
    background: url('../../../assets/img/mIndex/timeline1.png') no-repeat center;
}
/*.circle {*/
/*border-radius: 50%;*/
/*opacity: 0.3;*/
/*border: 3px solid #3ab161;*/
/*}*/
.qtt-list-item {
    margin-bottom: 2.035rem;
}
.qtt-list-left {
    vertical-align: top;
    margin-top: 2.285rem;
    display: inline-block;
    text-align: right;
    width: 40%;
}
.qtt-list-time {
    font-family: DINAlternate-Bold;
    font-size: 18px;
    color: #4a4a4a;
    letter-spacing: 1.29px;
}
.qtt-list-text {
    font-family: PingFangSC-Light;
    font-size: 12px;
    color: #000000;
    letter-spacing: 0.86px;
    line-height: 0.607rem;
}
.under-line {
    height: 2px;
    width: 0.928rem;
    display: inline-block;
    background: #3ab161;
    margin-top: 4px;
    vertical-align: top;
}
.web-logo-list {
    padding-top: 1.2rem;
    margin: 0 auto;
    width: auto;
    padding-left: 0.25rem;
}
.web-logo-list li {
    width: 33%;
    display: inline-block;
}
.web-logo-list li img {
    height: 100%;
    width: 100%;
}
.m-media-honor-wrapper {
    position: relative;
    display: block;
    margin-top: 33px;
    height: 16.6rem;
    width: 100%;
    /*overflow: hidden;*/
}
.m-media-honor-item {
    /*width: 7.857rem; 写好滑动释放出来替换*/
    height: 8.75rem;
    width: 45%;
    margin: 0 1%;
    display: inline-block;
    text-align: center;
}
.m-media-honor-item img {
    height: 5.5rem;
    width: 100%;
}
</style>
